import React, { useState } from "react";
import axiosInstance from "../api/axiosInstance";

export default function AdminSendCouponPage() {

  const [phone, setPhone] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState("");
  const [maxUses, setMaxUses] = useState("");

  const sendCoupon = async () => {

    try {

      const res = await axiosInstance.post(
        "/admin/send-coupon-whatsapp/",
        {
          phone,
          coupon_code: couponCode,
          discount,
          max_uses: maxUses,
        }
      );

      alert(res.data.message);

      setPhone("");
      setCouponCode("");
      setDiscount("");
      setMaxUses("");

    } catch (err) {

      console.error(err);

      alert(
        err.response?.data?.error ||
        "Failed to send coupon"
      );
    }
  };

  return (

    <div
      style={{
        maxWidth: 500,
        margin: "30px auto",
        padding: 20
      }}
    >

      <h2>🎁 Send Coupon WhatsApp</h2>

      <input
        placeholder="Phone Number"
        value={phone}
        onChange={(e)=>setPhone(e.target.value)}
        style={input}
      />

      <input
        placeholder="Coupon Code"
        value={couponCode}
        onChange={(e)=>setCouponCode(e.target.value)}
        style={input}
      />

      <input
        placeholder="Discount"
        value={discount}
        onChange={(e)=>setDiscount(e.target.value)}
        style={input}
      />

      <input
        placeholder="Max Uses"
        value={maxUses}
        onChange={(e)=>setMaxUses(e.target.value)}
        style={input}
      />

      <button
        onClick={sendCoupon}
        style={btn}
      >
        Send WhatsApp
      </button>

    </div>
  );
}

const input = {
  width: "100%",
  padding: 10,
  marginBottom: 10,
};

const btn = {
  width: "100%",
  padding: 12,
  background: "green",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
};